"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _UIStore = _interopRequireDefault(require("./UIStore.js"));

var _ConfigStore = _interopRequireDefault(require("./ConfigStore.js"));

var _ApiStore = _interopRequireDefault(require("./ApiStore.js"));

var _FormStore = _interopRequireDefault(require("./FormStore"));

var _LocalizationStore = _interopRequireDefault(require("./LocalizationStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RootStore = /*#__PURE__*/_createClass(function RootStore() {
  _classCallCheck(this, RootStore);

  if (!window._babelPolyfill) {
    require("@babel/polyfill"); //console.log('after @babel-polyfill');

  }

  this.localizationStore = new _LocalizationStore["default"](this);
  this.configStore = new _ConfigStore["default"](this);
  this.apiStore = new _ApiStore["default"](this);
  this.uIStore = new _UIStore["default"](this);
  this.formStore = new _FormStore["default"](this);
});

var Store = new RootStore();
var _default = Store;
exports["default"] = _default;